import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule} from '../devextreme.module';
import {EtsCommonModule} from '../common-services/common.module';
import {OrderPreviewTablesComponent} from './order-preview-tables.component';

@NgModule({
    imports: [CommonModule, DevExtremeModule, EtsCommonModule],
    declarations: [OrderPreviewTablesComponent],
    exports: [OrderPreviewTablesComponent]
})
export class OrderPreviewTablesModule {}
